//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Tab, Tabs, Switch,Loading ,Dialog ,Toast } from "vant";
import global from "../../../static/js/global.js";
import $ from "jquery";
export default {
  components: {
    $,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Switch.name]: Switch,
    [Loading.name]: Loading,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
  },
  data() {
    return {
      active:'',
      loging:true, // 是否显示加载
      show_1: false,
      check:[
        {checked_one: false},
        {checked_two: false},
      ],
      // checked_one: false,
      // checked_two: false,
      hsNo: "", // 房间号
      comnCode: "", // 小区编号
      family: "", // 家庭成员数据集
      ownersName: "", // 业主姓名
      visitor:'', // 访客成员数据集
      authFlag:'', // 认证标识（1已认证；0未认证）
      isApa:false,
      stu:'', // 状态 和当前状态相反
    };
  },
  beforeMount() {

    this.initial();
  },

  mounted() {
    if(this.$route.query.active){
      this.active = '1'
    }else{
      this.active = '0'
    }
    console.log(this.$router.history.current.query);
  },
  methods: {
    // 我的家属切换推送状态
    onInputJs(index,item) {
       console.log(index)
       console.log(item)
        if( this.family[index].isPush == true){
          Dialog.confirm({
          title: '提醒',
          message: '是否关闭推送状态？'
        }).then(() => {
          // 发送请求改变推送状态
          this.stu = '0'
          let status = new Object();
          status.configId = item.configId;
          status.isPush =  this.stu;
          status.comnCode =  this.comnCode;
          let newUrl = global.host + "guardInfo/updateGuardInfo";
          this.$http.post(newUrl, status).then(
          function(res) {
            if(res.body.statusCode == 110){
              this.family[index].isPush = false
            }else{
              alert('更改失败')
            }
          },
          function(err) {
            console.log(err);
            alert(err.body.message)
          }
        );
      });
      }else{
        this.stu = '1'
         let status = new Object();
         status.configId = item.configId;
         status.isPush =  this.stu;
         status.comnCode =  this.comnCode;
         let newUrl = global.host + "guardInfo/updateGuardInfo";
         this.$http.post(newUrl, status).then(
         function(res) {
           if(res.body.statusCode == 110){
             this.family[index].isPush = true
           }else{
             alert('更改失败')
           }
         },
         function(err) {
           console.log(err);
            alert(err.body.message)
          }
        );

      }


    },
    // 我的访客切换状态
    onInputFk(index,item) {
        console.log(index)
       console.log(item)
        if( this.visitor[index].isPush == true){
          Dialog.confirm({
          title: '提醒',
          message: '是否关闭推送状态？'
        }).then(() => {
          // 发送请求改变推送状态
          this.stu = '0'
          let status = new Object();
          status.configId = item.configId;
          status.isPush =  this.stu;
          status.comnCode =  this.comnCode;
          let newUrl = global.host + "guardVisitor/updateGuardVisitor";
          this.$http.post(newUrl, status).then(
          function(res) {
            if(res.body.statusCode == 110){
              this.visitor[index].isPush = false
            }else{
              alert('更改失败')
            }
          },
          function(err) {
            console.log(err);
            alert(err.body.message)
          }
        );
      });
      }else{
        this.stu = '1'
         let status = new Object();
         status.configId = item.configId;
         status.isPush =  this.stu;
         status.comnCode =  this.comnCode;
         let newUrl = global.host + "guardVisitor/updateGuardVisitor";
         this.$http.post(newUrl, status).then(
         function(res) {
           if(res.body.statusCode == 110){
             this.visitor[index].isPush = true
           }else{
             alert('更改失败')
           }
         },
         function(err) {
           console.log(err);
            alert(err.body.message)
          }
        );

      }


    },
    // 时间转换 公用
    renderTime(date) {
      var dateee = new Date(date).toJSON();
      return new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, " ");
    },
 // 家庭成员类逻辑
    // 删除家庭成员当前信息
    deleMember(item) {
      Dialog.confirm({
        title: '提示',
        message: '确认删除记录吗?'
      }).then(() => {
         Toast.loading({
        mask: true,
        forbidClick: true,
        duration:10000000,
        message: "删除中..."
      });
        this.$http.get(
          global.host + "guardInfo/deleteGuardInfo?configId=" + item.configId+"&comnCode="+this.comnCode
        ).then(
          function(res) {
            console.log('DDDDDDDDDDDDDDDDDDDDDDDDD')
            if(res.body.statusCode == '110'){
               Toast.success('删除成功');
             this.initial_home();
            }else{
              Toast.fail('删除失败');
            }
            console.log(res)
          },
          function(err) {
            Toast.fail('删除失败');
            console.log(err);
          }
        );
      }).catch(() => {
        // on cancel
      })
      console.log(item);

    },
    // 页面初始化 查房间号和编号
    initial() {
      let url =
        global.host + "users/getUserInfo?openid=" +
        this.$router.history.current.query.openid +
        "&phone=" +
        this.$router.history.current.query.phone;
      this.$http.get(url).then(
        function(res) {
          console.log("333333333333333333333");
          console.log(res.body);
          if(res.body.statusCode=='200'){
            this.comnCode = res.body.result.comnCode;
            this.hsNo = res.body.result.houseNo;
            this.ownersName = res.body.result.name;
            this.authFlag =res.body.result.authFlag;//res.body.result.authFlag;  // 如果是1 已认证 如果是0 未认证  isAuthFlag
            console.log(this.authFlag);
             this.initial_home();
            this.initial_visitor();
            if(this.authFlag == '1'){
              this.isApa = true;
            }else{
            this.isApa = false;
            }
            console.log(this.isApa)
            console.log(this.ownersName);

          }
        },
        function(err) {
          console.log(err);
        }
      );
    },
    // 页面初始化 查询成员信息
    initial_home() {
      let initial_home = new Object();
      initial_home.comnCode = this.comnCode;
      initial_home.hsNo = this.hsNo;
      let newUrl = global.host + "guardInfo/findGuardInfo";
      this.$http.post(newUrl, initial_home).then(
        function(res) {
          console.log("xxxxxxfamilyxxxxxx");
          console.log(res);
          this.loging = false;
          this.family = res.body.result;
          for (var i = 0; i < this.family.length; i++) {
            if (this.family[i].relation == "0") {
              this.family[i].relation = "本人";
            } else if (this.family[i].relation == "1") {
              this.family[i].relation = "父母";
            } else if (this.family[i].relation == "2") {
              this.family[i].relation = "子女";
            } else if (this.family[i].relation == "3") {
              this.family[i].relation = "父亲";
            }else if (this.family[i].relation == "4") {
              this.family[i].relation = "兄妹";
            }else if (this.family[i].relation == "5") {
              this.family[i].relation = "其他";
            }

            if(this.family[i].isPush == "0"){
                    this.family[i].isPush =false
                  }else{
                     this.family[i].isPush =true
                  }
                    var phoneReg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/;
                  if(this.family[i].telephone == null){
                    this.family[i].telephone =null
                  }else if(!phoneReg.test(this.family[i].telephone)){
                      this.family[i].telephone =null
                  }
            this.family[i].createTime = this.renderTime(
              this.family[i].createTime
            );
          }
        },
        function(err) {
          console.log(err);
        }
      );
    },

    // 跳转新增家属
    getAddFamily() {
      console.log(this.$router.history.current.query.openid);
      console.log(this.$router.history.current.query.phone);
      this.$router.push({
        path: "/addFamily",
        query: {
          ownersName: this.ownersName,
          hsNo: this.hsNo,
          comnCode: this.comnCode,
          openid: this.$router.history.current.query.openid,
          phone: this.$router.history.current.query.phone
        }
      });
    },
    // 访客逻辑
     // 页面初始化 查询访客信息
    initial_visitor(){
      let initial_visitor = new Object();
            initial_visitor.comnCode = this.comnCode;
            initial_visitor.hsNo = this.hsNo;
            let newUrl = global.host + "guardVisitor/findGuardVisitor";
            this.$http.post(newUrl, initial_visitor).then(
              function(res) {
                console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");
                console.log(res);
                this.loging = false;
                this.visitor = res.body.result;
                for (var i = 0; i < this.visitor.length; i++) {
                  if (this.visitor[i].relation == "1") {
                    this.visitor[i].relation = "亲戚";
                  } else if (this.visitor[i].relation == "2") {
                    this.visitor[i].relation = "朋友";
                  } else if (this.visitor[i].relation == "3") {
                    this.visitor[i].relation = "同事";
                  } else if (this.visitor[i].relation == "4") {
                    this.visitor[i].relation = "其他";
                  }
                  if(this.visitor[i].isPush == "0"){
                    this.visitor[i].isPush =false
                  }else{
                     this.visitor[i].isPush =true
                  }
                  var phoneReg = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/;
                  if(this.visitor[i].telephone == null){
                    this.visitor[i].telephone =null
                  }else if(!phoneReg.test(this.visitor[i].telephone)){
                      this.visitor[i].telephone =null
                  }
                  this.visitor[i].createTime = this.renderTime(
                    this.visitor[i].createTime
                  );
                }
              },
              function(err) {
                console.log(err);
              }
            );
    },
    // 删除访客记录
    deleVisitor(item){
      Dialog.confirm({
        title: '提示',
        message: '确认删除记录吗?'
      }).then(() => {
        Toast.loading({
        mask: true,
        forbidClick: true,
        duration:10000000,
        message: "删除中..."
      });

        this.$http.get(
          global.host +
            "guardVisitor/deleteGuardVisitor?configId=" +
            item.configId+"&comnCode="+this.comnCode
        ).then(
          function(res) {
            console.log('xxx')
            console.log(res);
            if(res.body.statusCode == '110'){
              Toast.success('删除成功');
               this.initial_visitor();
            }else{
               Toast.fail('删除失败');
            }
          },
          function(err) {
            Toast.fail('删除失败');
            console.log(err);
          }
        );
      }).catch(() => {
        // on cancel
      });
       console.log(item);

    },
    // 跳转新增访客
    getAddVisitor() {
      this.$router.push({ path: "/addVisitor" ,query: {
          ownersName: this.ownersName,
          hsNo: this.hsNo,
          comnCode: this.comnCode,
          openid: this.$router.history.current.query.openid,
          phone: this.$router.history.current.query.phone
        }});
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/entrance/accessControl.vue